import { theme } from 'antd'
import { ReactNode, useMemo } from 'react'
import { DetailsPageLayout } from '../../../components'
import { WorkspaceTab, workspaceTabs } from '../WorkspaceDetailsPage'

const { useToken } = theme

interface DocumentSetDetailsPageLayoutProps {
  children?: ReactNode
  selectedWorkspaceTab: WorkspaceTab
}

const DocumentSetDetailsPageLayout = ({
  children,
  selectedWorkspaceTab,
}: DocumentSetDetailsPageLayoutProps) => {
  const { token } = useToken()

  const layoutBgColor = useMemo(() => {
    switch (selectedWorkspaceTab) {
      case workspaceTabs.INFO:
        return token.colorFillAlter
      case workspaceTabs.SMART_FUNCTION:
        return token.colorBgLayout
      default:
        return token.colorFillAlter
    }
  }, [token, selectedWorkspaceTab])

  return (
    <DetailsPageLayout $bgColor={layoutBgColor}>{children}</DetailsPageLayout>
  )
}

export default DocumentSetDetailsPageLayout
